import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  
      public static url: string;

      set(tempUrl:string){
        TokenService.url = tempUrl.split('=')[1];
      }

}
